import ConfirmationDialog from 'components/ReusableComponents/ConfirmationDialog'
import DragAndDropUploader from 'components/ReusableComponents/DragAndDropUploader'
import DownloadIcon from 'components/ReusableComponents/Icons/DownloadIcon'
import usePlausible from 'hooks/usePlausible'
import { useState } from 'react'

import { ReactComponent as ExcelIcon } from './excel.svg'
import styles from './UploadConsentListDialog.module.scss'

const UploadConsentListDialog = ({ onClose, type }) => {
  const { postEvent, plausibleEvents } = usePlausible()
  const [openInfoDialog, setDialogVisible] = useState(false)
  return (
    <>
      <ConfirmationDialog
        title={
          type === 'optin' ? 'Upload opted-in guest list' : `Upload "Do not call" list`
        }
        onClose={onClose}
        maxWidth={500}
        hasConfirmButton={false}
      >
        <div className={styles.header}>
          <ExcelIcon />
          <p className={styles.description}>
            Upload a CSV or excel file following the template below. Use yyyy-mm-dd format
            for dates.
          </p>
        </div>
        <div className={styles.dropZone}>
          <DragAndDropUploader
            url="/accounts/upload"
            onData={formData => {
              formData.append('isConsentGivenList', type === 'optin')
              formData.append('overrideEmptyLastCheckout', true)

              return formData
            }}
            onLoad={() => {
              postEvent(
                type === 'optin'
                  ? plausibleEvents.UploadedOptedInGuestList
                  : plausibleEvents.UploadedOptedOutGuestList
              )
              setDialogVisible(true)
            }}
            maxFileSize="100MB"
            acceptedFileTypes={['text/csv']}
            onError={res => console.warn('file response', res)}
            labelIdle="
              <p class='filepond-p'>drop a file here</p>
              <span class='filepond-or'>or</span> <span class='filepond--label-action'>Select file</span>"
            labelFileProcessingError={err => `${err.code} - Something went wrong`}
          />
        </div>
        <a
          href="/compliance-template.csv"
          download={true}
          className={styles.downloadLink}
        >
          <DownloadIcon /> Download CSV template
        </a>
      </ConfirmationDialog>
      {openInfoDialog && (
        <ConfirmationDialog
          title="File upload messaging"
          positiveMessage="Okay"
          onConfirm={() => onClose()}
          theme="blacklist"
        >
          <div>Your file is being processed in the background</div>
        </ConfirmationDialog>
      )}
    </>
  )
}

export default UploadConsentListDialog
